import type { StoredTreasuryState, TreasurySettings } from './types';

export const defaultCategories = [
  'Benevolent support',
  'Groundwork',
  'Statutory payments',
  'Missions support',
  'Building/repairs',
  'Transport',
  'Utilities',
  'Supplies',
  'Bank charges',
  'Other'
];

export const defaultSettings: TreasurySettings = {
  churchName: '',
  currency: 'GHS',
  firstReportMonth: '',
  openingBalances: {
    cash: 0,
    bank: 0,
    mission: 0
  },
  openingBalancesConfirmed: false,
  missionFundRate: 0,
  reportDisplay: {
    showBalanceColumn: true,
    showCashBalance: true,
    showBankBalance: true,
    showMissionBalance: true,
    showNotesColumn: true
  },
  categories: defaultCategories
};

export const defaultState: StoredTreasuryState = {
  settings: defaultSettings,
  transactions: [],
  reportNotes: {}
};

export const freshState: StoredTreasuryState = defaultState;
